import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import NumberAutocomplete from '../components/NumberAutocomplete';
import { addBulkBoxSession, changeBulkBoxSession } from '../actions/BoxSessionLogging';

const AddPhone = ({ isOpen, onCancel, onConfirm, phone, data, showNumberModal }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState(data || {});
  const [num, setNum] = useState();
  const handleChange = e => {
    if (!data) {
      if (e.currentTarget.name === 'displayName') {
        // [BulkAction] - Add
        dispatch(addBulkBoxSession(`display name added - ${e.currentTarget.value}`, 'displayName'));
      }
      if (e.currentTarget.name === 'extension') {
        // [BulkAction] - Add
        dispatch(addBulkBoxSession(`Extension added - ${e.currentTarget.value}`, 'extension'));
      }
      if (e.currentTarget.name === 'model') {
        // [BulkAction] - Add
        dispatch(addBulkBoxSession(`Model name added - ${e.currentTarget.value}`, 'model'));
      }
    } else {
      if (e.currentTarget.name === 'displayName') {
        // [BulkAction] - Change
        dispatch(
          changeBulkBoxSession(
            `Display name updated from ${state?.displayName || '-'} to ${e.currentTarget.value}`,
            'displayName',
          ),
        );
      }
      if (e.currentTarget.name === 'extension') {
        // [BulkAction] - Change
        dispatch(
          changeBulkBoxSession(
            `Display name updated from ${state?.extension || '-'} to ${e?.currentTarget?.value}`,
            'extension',
          ),
        );
      }
      if (e.currentTarget.name === 'model') {
        // [BulkAction] - Change
        dispatch(
          changeBulkBoxSession(
            `Model name updated form ${state?.model || '-'} to ${e?.currentTarget?.value}  `,
            'Model',
          ),
        );
      }
    }
    setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
  };

  const onNumberSelect = e => {
    if (!data) {
      // [BulkAction] - Add
      dispatch(addBulkBoxSession(`Phone Number Added - ${e?.value} `, 'addNumber'));
    } else {
      // [BulkAction] - change
      dispatch(
        changeBulkBoxSession(
          `Phone Number updated from ${state?.number?.number || '-'} to ${e?.value}`,
          'Number',
        ),
      );
    }
    if (e.suggestion !== null) {
      setNum(e.suggestion);
      setState({ ...state, number: e.suggestion._id });
    } else {
      setNum('');
      setState({ ...state, number: '' });
    }
  };

  useEffect(() => {
    setState(data || {});
    setNum((data && data.number) || {});
  }, [data]);

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Add New Phone</ModalHeader>
      <ModalBody>
        <div className="container">
          <FormGroup row>
            <Label for="name" sm={4}>
              Display Name:
            </Label>
            <Col sm={9}>
              <Input
                onChange={handleChange}
                placeholder="Please specify"
                required
                value={state.displayName}
                type="text"
                name="displayName"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="name" sm={4}>
              Extension:
            </Label>
            <Col sm={9}>
              <Input
                onChange={handleChange}
                placeholder="Please specify"
                required
                value={state.extension}
                type="number"
                name="extension"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Row style={{ margin: '0px' }}>
              <Label for="name" sm={4}>
                Number:
              </Label>
              <Col sm={9}>
                {phone.numbers.length !== 0 ? (
                  <NumberAutocomplete
                    searchTerm={(state.number && state.number.number) || ''}
                    placeholder="Select Number"
                    numbers={phone.numbers}
                    onChange={onNumberSelect}
                  />
                ) : (
                  <Alert colSpan={2} color="info" className="price-not-found-alert">
                    No Number(s) found
                  </Alert>
                )}
              </Col>

              {state.extension && state.extension !== '' && state.number && state.number !== '' ? (
                <Col sm={3}>
                  <Button onClick={() => showNumberModal(state, num)}>Edit</Button>
                </Col>
              ) : null}
            </Row>
          </FormGroup>

          <FormGroup row>
            <Label for="name" sm={4}>
              Model:
            </Label>
            <Col sm={9}>
              <Input
                onChange={handleChange}
                placeholder="Please specify"
                required
                value={state.model}
                type="text"
                name="model"
              />
            </Col>
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={() => onConfirm(state)}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddPhone;
